import { atom } from 'jotai';
import { atomWithReset } from 'jotai/utils';

import { NetSuiteFieldsExpenseReport } from '../data/types';

export const netSuiteExpenseReportFieldValuesState = atomWithReset<Partial<NetSuiteFieldsExpenseReport>>({});

export const netSuiteAttachmentUploadingLineIdsState = atom<string[]>([]);
